var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region EmployeeDetailDay - Ctor
    ns.EmployeeDetailDay = function EmployeeDetailDay(reservations, schedules, dayOfWeek, dayName, employeeID, activityID) {
        this.initialize(reservations, schedules, dayOfWeek, dayName, employeeID, activityID);
    }
    // #endregion

    // #region EmployeeDetailDay - Inheritance

    ns.EmployeeDetailDay.prototype = new ns.ScheduleResourceDetailDayBase();
    ns.EmployeeDetailDay.prototype.constructor = ns.EmployeeDetailDay;
    ns.EmployeeDetailDay.prototype.parent = ns.ScheduleResourceDetailDayBase.prototype;

    // #endregion

    // #region EmployeeDetailDay - Methods
    ns.EmployeeDetailDay.prototype.createReservation = function (activityScheduleID) {
        return {
            activityInstructorID: 0,
            activityID: this.activityID,
            employeeID: this.resourceID,
            activityScheduleID: activityScheduleID,
            firstPeriodStartDate: null,
            firstPeriodEndDate: null,
            secondPeriodStartDate: null,
            secondPeriodEndDate: null,
            notes: null
        };
    }

}(webooker_acivity_models));
